import React from 'react';

const About = () => {
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container-custom">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Image Side - Updated to show full image */}
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl bg-gray-200 flex items-center justify-center h-[500px]">
              <img 
                src="https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
                alt="Yousuf Shaik - Founder of PropWhiz" 
                className="w-full h-full object-contain"
              />
            </div>
            
            {/* Dallas Badge */}
            <div className="absolute -bottom-4 -right-4 bg-white p-4 rounded-2xl shadow-xl">
              <div className="flex items-center gap-3">
                <svg className="w-8 h-8 text-propwhiz-accent" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
                </svg>
                <div>
                  <div className="text-2xl font-bold text-propwhiz-dark">Dallas</div>
                  <div className="text-sm text-gray-600">Local Expert</div>
                </div>
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div>
            <span className="text-propwhiz-accent font-semibold text-lg mb-2 block">Meet The Founder</span>
            <h2 className="text-4xl md:text-5xl font-bold text-propwhiz-dark mb-6">
              Hi, I'm Yousuf Shaik
            </h2>
            
            {/* ... Rest of your About component stays exactly the same ... */}
            <div className="flex items-center gap-2 bg-white p-3 rounded-xl mb-6 inline-block">
              <span className="font-medium">Dallas Local & Proud</span>
            </div>

            <p className="text-xl text-gray-700 mb-6 leading-relaxed">
              I started PropWhiz with a simple goal: to help Dallas homeowners sell their properties on their terms, without the usual stress and uncertainty.
            </p>
            <p className="text-gray-600 mb-6 leading-relaxed">
              We're not just real estate investors — we're your neighbors. Based right here in Dallas, our team provides honest, straightforward solutions whether you're facing foreclosure, need to relocate, or simply want to sell without the hassle.
            </p>
            
            <div className="grid grid-cols-2 gap-4 mb-8">
              <div className="bg-white p-4 rounded-xl shadow-md">
                <div className="text-3xl font-bold text-propwhiz-accent">50+</div>
                <div className="text-sm text-gray-600">Dallas Homes Bought</div>
              </div>
              <div className="bg-white p-4 rounded-xl shadow-md">
                <div className="text-3xl font-bold text-propwhiz-accent">100%</div>
                <div className="text-sm text-gray-600">Dallas Local</div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-lg">
              <h3 className="font-bold text-lg mb-3">Contact Me Directly:</h3>
              <div className="space-y-3">
                <a href="tel:9722553567" className="flex items-center gap-3 text-gray-700 hover:text-propwhiz-accent group">
                  <div className="bg-gray-100 p-2 rounded-lg group-hover:bg-propwhiz-accent/10">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>
                  </div>
                  <span className="font-semibold">(972) 255-3567</span>
                </a>
                <a href="mailto:Ys3291193@gmail.com" className="flex items-center gap-3 text-gray-700 hover:text-propwhiz-accent group">
                  <div className="bg-gray-100 p-2 rounded-lg group-hover:bg-propwhiz-accent/10">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
                  </div>
                  <span className="font-semibold">Ys3291193@gmail.com</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;